export default [
  { title: 'Projetos' },
  { title: 'Sobre' },
  { title: 'Serviços' },
  { title: 'Contatos', path: '/contatos' },
];
